import { FC } from 'react';

import { FileBrowserStorageObjectFragment } from '../../graphql/generated';
import { isFile } from '../../graphql/utils/utils';
import { FileSize } from '../file/file-size';
import { Placeholder } from './file-browser';

type Props = {
  object: FileBrowserStorageObjectFragment;
};

export const EnhancedFileSize: FC<Props> = ({ object }) => {
  return isFile(object) ? <FileSize>{object.size}</FileSize> : <Placeholder />;
};
